/**
 * Check if stars and text should be reduced based on likes and super likes
 * @param {number} ratingCount
 * @param {number} likedCount
 * @param {number} superLikedCount
 * @returns {boolean}
 */
const shouldReduceStarsAndTextBasedOnLikesUtil = (ratingCount, likedCount, superLikedCount, isFromProductPage) => {
  if (isFromProductPage) {
    return false
  }

  if ((ratingCount > 0 && likedCount > 0 && superLikedCount > 0)) {
    return true
  }

  if ((ratingCount > 100 && ratingCount < 1000) &&
    ((likedCount > 100 && likedCount < 1000) || (superLikedCount > 100 && superLikedCount < 1000))) {
    return true
  }

  return false
}

export default shouldReduceStarsAndTextBasedOnLikesUtil
